import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Pagination } from "../../../../common/pagination";
import ModernPagination from "../../../../common/pagination/ModernPagination";
import Heading from '../../../../common/element/Heading';
import ClientInput from "../../../../common/element/Input/clientInput";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../redux/Admin/breadcrumbsSlice";
import { useDispatch, useSelector } from 'react-redux';
import { getCompanyProspectListing } from '../../../../redux/ProspectCompany/companyProspectSlice';
import {
  selectCompanyProspectList,
  selectCompanyProspectListLoading,
  selectCompanyProspectListTotal
} from '../../../../redux/ProspectCompany/companyProspectSelectors';

import HomeActivityList from './ProspectCompany';
import AddEditHomeworkActivity from './AddEdit';
import AddEditCompany from '../Companies/AddEdit';

const ProspectCompany = () => {
  const dispatch = useDispatch();

  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [convertDialogOpen, setConvertDialogOpen] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [selectedConvertActivity, setSelectedConvertActivity] = useState(null);
  const [dialogMode, setDialogMode] = useState('add');

  const companyList = useSelector(selectCompanyProspectList);
  const totalCount = useSelector(selectCompanyProspectListTotal);
  const isLoading = useSelector(selectCompanyProspectListLoading);

  const [getFilterData, SetFilterData] = useState({
    page: 1,
    limit: 10,
    search: "",
  });

  const totalPages = Math.ceil(totalCount / filterlimit);

  // Search Data
  const handleSearch = (e) => {
    const value = e.target.value.trim();
    SetFilterData((prevalue) => ({
      ...prevalue,
      search: value,
      page: 1
    }));
    setfilterpage(1);
  };

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Prospect Company",
          url: "/prospectCompany",
          home: "/companies",
        },
      ])
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(getCompanyProspectListing({
      page: filterpage,
      limit: filterlimit,
      search: getFilterData.search
    }));
  }, [dispatch, filterpage, filterlimit, getFilterData.search]);

  const inputchangehandler = useCallback(debounce(handleSearch), []);

  const handlePageChange = (page) => {
    setfilterpage(page);
  };

  const handleAddActivity = () => {
    setSelectedActivity(null);
    setDialogMode('add');
    setDialogOpen(true);
  };

  const handleEditActivity = (activity) => {
    setSelectedActivity(activity);
    setDialogMode('edit');
    setDialogOpen(true);
  };

  const handleConvertActivity = (activity) => {
    setSelectedConvertActivity(activity);
    setConvertDialogOpen(true);
  };

  const handleDialogClose = (refresh = false) => {
    setDialogOpen(false);
    setSelectedActivity(null);
    setDialogMode('add');
    // always refresh the listing when modal closes so UI stays in sync
    dispatch(getCompanyProspectListing({
      page: filterpage,
      limit: filterlimit,
      search: getFilterData.search
    }));
  };

  const handleConvertDialogClose = () => {
    setConvertDialogOpen(false);
    setSelectedConvertActivity(null);
    dispatch(getCompanyProspectListing({
      page: filterpage,
      limit: filterlimit,
      search: getFilterData.search
    }));
  };

  return (
    <React.Fragment>
      <div>
        <p className="text-gray-600 my-3"></p>
      </div>

      <div className="flex justify-between mb-5">
        <div className="w-80 h-10 text-start">
          <Heading>Prospect Company</Heading>
        </div>

        <div className="flex gap-2">
          <BtnPrimary
            onClick={handleAddActivity}
            className="text-xs h-9 flex items-center justify-center px-3 gap-1"
          >
            Add Prospect Company
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.712 4.167v11.666M4.878 10h11.667"
                stroke="#fff"
                strokeWidth="1.667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </BtnPrimary>
        </div>
      </div>

      <div className="flex justify-end mb-4">
        <div className="input-wrapper">
          <div className="input-suffix-start left-3.5">
            <img
              src="/assets/icons-svg/search-lg.svg"
              alt=""
              className="h-5"
            />
          </div>
          <ClientInput
            type="text"
            className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Search"
            inputchangehandler={inputchangehandler}
            name={"search"}
          />
        </div>
      </div>

      <HomeActivityList
        sampleData={companyList}
        onEdit={handleEditActivity}
        onConvert={handleConvertActivity}
        isLoading={isLoading}
        filterpage={filterpage}
        filterlimit={filterlimit}
        search={getFilterData.search}
      />

      <AddEditHomeworkActivity
        dialogOpen={dialogOpen}
        onDialogClose={handleDialogClose}
        companyData={selectedActivity}
        isEdit={dialogMode === 'edit'}
      />

      {convertDialogOpen && (
        <AddEditCompany
          dialogOpen={convertDialogOpen}
          onDialogClose={handleConvertDialogClose}
          companyData={selectedConvertActivity}
          isEdit={false}
          isConvert={true}
          refreshList={handleConvertDialogClose}
        />
      )}

      <div className="flex justify-between items-center mt-3">
        <Pagination
          totalCount={totalCount}
          pageNumber={filterpage}
          displayPage={companyList?.length}
          UpdatePageLimit={setfilterlimit}
          UpdatePage={setfilterpage}
        />

        {totalCount > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default ProspectCompany;